var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('bottom-sheet', _vm._b({
    attrs: {
      "fullscreen": "",
      "persistent": "",
      "width": "720",
      "maxWidth": "100%"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (bind) {
        return [_vm._t("activator", null, null, bind)];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, 'bottom-sheet', {
    title: _vm.title
  }, false), [_c('v-layout', {
    staticClass: "bottom-sheet__contents h-100",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('v-sheet', {
    staticClass: "scroll-primary",
    staticStyle: {
      "flex": "1 1 auto",
      "overflow-x": "hidden",
      "overflow-y": "auto"
    }
  }, [_c('vertical-form-table', _vm._b({
    staticClass: "mb-20 mb-lg-40 mx-8",
    on: {
      "input": _vm.emit
    },
    scopedSlots: _vm._u([{
      key: _vm.ITEM_TERM_CATEGORY,
      fn: function () {
        return [_c('form-category', {
          on: {
            "input": _vm.emit
          },
          model: {
            value: _vm.form,
            callback: function ($$v) {
              _vm.form = $$v;
            },
            expression: "form"
          }
        })];
      },
      proxy: true
    }, {
      key: _vm.ITEM_TERM_CODE,
      fn: function () {
        return [_c('form-code', {
          on: {
            "input": _vm.emit
          },
          model: {
            value: _vm.form,
            callback: function ($$v) {
              _vm.form = $$v;
            },
            expression: "form"
          }
        })];
      },
      proxy: true
    }, {
      key: _vm.ITEM_TERM_VIDEO,
      fn: function () {
        return [_c('form-video', {
          on: {
            "input": _vm.emit
          },
          model: {
            value: _vm.form,
            callback: function ($$v) {
              _vm.form = $$v;
            },
            expression: "form"
          }
        })];
      },
      proxy: true
    }, {
      key: _vm.ITEM_TERM_LINKS,
      fn: function () {
        return [_c('form-links', {
          on: {
            "input": _vm.emit
          },
          model: {
            value: _vm.form,
            callback: function ($$v) {
              _vm.form = $$v;
            },
            expression: "form"
          }
        })];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'vertical-form-table', {
    items: _vm.items
  }, false))], 1), _c('div', {
    staticClass: "v-btn-group flex-wrap"
  }, [_c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": function ($event) {
        _vm.shows = false;
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("취소하기")])]), _c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm.isCreate ? [_c('span', [_vm._v(" 등록하기 ")])] : [_c('span', [_vm._v(" 수정하기 ")])]], 2)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }